var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreenIcon24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3F933A10-F661-4C69-98DC-ADC1A5C5B94E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems/Checkmark/Secondary/24",
    fill: "#008200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M16.901875,6.5 L9.804125,13.5710416 L7.094,10.8691209 L5.125,12.8342773 L9.804125,17.5 L18.875,8.46244767 L16.901875,6.5 Z",
    id: "Checkmark"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreenIcon24);
export default __webpack_public_path__ + "static/media/checkmark_green-icon_24.c5c6bebd9c50364cbb95edd3bf94040a.svg";
export { ForwardRef as ReactComponent };